export default __webpack_public_path__ + "4cf9f0ba52984f9c60a21c7fc2a4352c.png";